module.exports = __webpack_public_path__ + "assets/plant.9330fc24.svg";